import { ceil as lo_ceil } from 'es-toolkit/compat';

export const convertGramsToLb = (val: number): number => {
    return lo_ceil(val * 0.0022046, 2);
};

export const convertLbToGrams = (val: number): number => {
    return lo_ceil(val / 0.0022046, 2);
};

export const convertKgToLb = (val: number): number => {
    return lo_ceil(val * 2.204623, 2);
};

export const convertLbToKg = (val: number): number => {
    return lo_ceil(val / 2.204623 , 2);
};

export const convertGramsToKg = (val: number): number => {
    return lo_ceil(val / 1000 , 2);
};

export const convertKgToGrams = (val: number): number => {
    return lo_ceil(val * 1000 , 2);
};
